if (!customElements.get('groov-contact')) {
  customElements.define('groov-contact', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.tabs = Array.from(this.querySelectorAll('[data-contact-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-contact-panel]'));
      const tablist = this.querySelector('[role="tablist"]');
      if (!tablist || !this.tabs.length) return;

      window.addEventListener('message', (event) => {
        const calendar = this.querySelector('iframe[data-src]');
        if (!calendar || event.origin !== 'https://calendly.com' || event.source !== calendar.contentWindow) return;
        // Use the height reported by Calendly for each booking step and viewport.
        if (event.data?.event === 'calendly.page_height') {
          const height = Number.parseFloat(event.data.payload?.height);
          if (Number.isFinite(height) && height > 0) {
            calendar.style.height = `${Math.ceil(height)}px`;
          }
        }

      }, { signal });

      tablist.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-contact-tab]');
        if (this.tabs.includes(tab)) this.activateTab(tab);
      }, { signal });

      tablist.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target.closest('[data-contact-tab]'));
        if (index < 0) return;

        const rtl = getComputedStyle(tablist).direction === 'rtl';
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = index + (rtl ? -1 : 1);
        else if (event.key === 'ArrowLeft') nextIndex = index + (rtl ? 1 : -1);
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;

        event.preventDefault();
        const tab = this.tabs[(nextIndex + this.tabs.length) % this.tabs.length];
        this.activateTab(tab);
        tab.focus();
      }, { signal });

      this.querySelectorAll('form').forEach((form) => {
        form.addEventListener('submit', () => {
          // Remember only the submitted panel so Shopify feedback returns to it.
          try {
            sessionStorage.setItem(this.storageKey, form.closest('[data-contact-panel]').id);
          } catch (_) { /* The form also works when browser storage is unavailable. */ }
        }, { signal });
      });

      const restorePanel = () => {
        let target;
        try {
          target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
        } catch (_) { /* Ignore malformed URL fragments. */ }

        let panel = target && this.contains(target) ? target.closest('[data-contact-panel]') : null;
        if (!panel && (new URLSearchParams(location.search).has('contact_posted') || this.querySelector('.banner--error'))) {
          try {
            panel = this.panels.find((candidate) => candidate.id === sessionStorage.getItem(this.storageKey));
          } catch (_) { /* Default to support if storage is unavailable. */ }
        }

        this.activateTab(this.tabs.find((tab) => tab.getAttribute('aria-controls') === panel?.id) || this.tabs[0]);
      };

      restorePanel();
      window.addEventListener('hashchange', restorePanel, { signal });
    }

    get storageKey() {
      return `groov-contact:${this.id}:submitted-panel`;
    }

    activateTab(tab) {
      const panelId = tab.getAttribute('aria-controls');
      this.tabs.forEach((candidate) => {
        const active = candidate === tab;
        candidate.setAttribute('aria-selected', String(active));
        candidate.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
        if (!panel.hidden) {
          const calendar = panel.querySelector('iframe[data-src]');
          if (calendar && !calendar.hasAttribute('src')) {
            const url = new URL(calendar.dataset.src);
            url.searchParams.set('embed_domain', location.host);
            url.searchParams.set('embed_type', 'Inline');
            calendar.src = url.toString();
          }
        }
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
